<template>
    <div>
      <b-field grouped>
        <kyc-search v-focus/>
        <p class="control">
          <file-manager-select
            label="File Manager"
            :value="$store.state.staffIdFilterBy"
            @value-changed="$store.dispatch('setStaffIdFilterBy', { staffIdFilterBy: $event })"
          />
        </p>
        <p class="control">
          <b-field label="Status">
            <b-select
              placeholder="Select status"
              icon="account"
              v-model="$store.state.statusIdFilterBy"
              @input="$store.dispatch('setStatusIdFilterBy', { statusIdFilterBy: $event })"
              expanded
            >
              <option value="" selected>All</option>
              <option
                v-for="status in $store.state.formStatuses"
                :key="status.id"
                :value="status.id"
              >{{status.name}}</option>
            </b-select>
          </b-field>
        </p>
      </b-field>

      <b-field>
        <b-checkbox
          v-model="$store.state.listShowCompletedForms"
          @value-changed="$store.dispatch('setShowCompleted', { showCompleted: $event })"
        >Show completed</b-checkbox>
      </b-field>
    </div>
</template>

<script>
import KycSearch from '@/components/KycSearch'
import FileManagerSelect from '@/components/FileManagerSelect'

export default {
  name: 'KycAdminFilters',
  components: {
    KycSearch,
    FileManagerSelect
  },
  data () {
    return {
    }
  }
}
</script>
